import './SPQuestionnaire.scss';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { isEmpty } from '../../../../pages/SellerProfile/APIs/Helpers';
import SPQForm from './SPQForm';
import SPQFormButton from './SPQFormButton';
import { useTranslation } from 'react-i18next';
import { setOnboardingStatus,setShowSuccessPopUp,setErrorMsg ,
  setOnboardCompletePopupDetails,setDisabledBttn} from '../../../../redux/slices/sellerProfileSlice';
import { useSelector, useDispatch } from 'react-redux';
import { submitQuestionnaireRequest, SpQAPIsubmitQuestionnaireStart, setSubmitSuccess } from '../../../../redux/slices/questionnaireSlice';

const SPQuestionnaire = ({
  questionnaireFormData,
  getQuestion,
  user_id,
  isPostQuestionnaire
}) => {
  const dispatch = useDispatch();
  //const { onboardingStatus ,disabledBttn} = useSelector((state: any) => state.sellerProfile);
  const { onboardingStatus,formUpdates,disabledBttn } = useSelector((state: any) => state.sellerProfile);
  const { t, i18n } = useTranslation();

  // eslint-disable-next-line
  const [updateQuestionnaireForm, setUpdateQuestionnaireForm] = useState({});

  const { loading, submissionSuccess, submitSuccess } = useSelector((state: any) => state.questionnaire);

  useEffect(() => {
    if (questionnaireFormData) {
      setUpdateQuestionnaireForm(questionnaireFormData);
    }
  }, [questionnaireFormData]);

  const displayErrorByType = (error) => {
    if (error.response?.data?.err_code === 402) {
      dispatch(setErrorMsg(t('sellerProfile.dashboard.questionnaireAlreadySubmitted')));
    } else {
      dispatch(setErrorMsg(t('sellerProfile.dashboard.errorSubmittingQuestionnaire')));
    }
  };


  useEffect(() => {
    if (submitSuccess) {
      const successMsg = t('sellerProfile.dashboard.questionnaireSubmitted');
     dispatch(setShowSuccessPopUp(
       successMsg
      ));
      dispatch(setDisabledBttn({
        ...disabledBttn,
        [`updateQuestionnaire`]: true
      }));
      if (onboardingStatus.completed === 2) {
        dispatch(setOnboardCompletePopupDetails({
          show: true,
          navigate: true,
          close: false
        }));
      } else {
        getQuestion(user_id);
      }
      dispatch(setSubmitSuccess(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitSuccess, onboardingStatus]);


  const submitFormFields = async () => {
    try {
      dispatch(SpQAPIsubmitQuestionnaireStart({
        formUpdates: formUpdates,
        user_id: user_id,
        language: i18n.language
      }))
    } catch (error) {
      console.log(error);
      displayErrorByType(error);
    }
  };


  useEffect(() => {
    if (submissionSuccess) {
      const successMsg = t('sellerProfile.dashboard.questionnaireSubmitted');
      dispatch(setShowSuccessPopUp(
       successMsg
      ));
      dispatch(setDisabledBttn({
        ...disabledBttn,
        [`questionnaire`]: true
      }));

      if (onboardingStatus?.completed === 2) {
        let statusChange = {};

        statusChange[`completed`] = 3;
        statusChange[`questionnaire`] = true;
        statusChange[`notification`] = true;
        statusChange[`user`] = true;

        dispatch(setOnboardingStatus({ ...statusChange }));

        dispatch(setOnboardCompletePopupDetails({
          show: true,
          navigate: false,
          close: false
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionSuccess, onboardingStatus])

  const submitPostFormFields = async () => {
    try {
      dispatch(submitQuestionnaireRequest({
        formUpdates: formUpdates,
        user_id: user_id,
        language: i18n.language
      }));
    } catch (error) {
      displayErrorByType(error);
    }
  };

  return !isEmpty(updateQuestionnaireForm) ? (
    <Box className="questionnaireBox">
      <Typography sx={{ marginBottom: '35px' }}>
        {t('sellerProfile.dashboard.headerSubmitQuestionnaire')}
      </Typography>
      <form>
        <SPQForm
          cols="single"
          compName="questionnaire"
          formFields={updateQuestionnaireForm}
          formName={
            isPostQuestionnaire ? 'questionnaire' : 'updateQuestionnaire'
          }
          key="questionnaire"
        />
        <div className="questionnaireButton">
          {
            <SPQFormButton
              compName="SPQuestionnaire"
              formName={
                isPostQuestionnaire ? 'questionnaire' : 'updateQuestionnaire'
              }
              label={t('sellerProfile.dashboard.submitQuestionnaire')}
              showLoading={loading}
              handleClick={() => {
                if (isPostQuestionnaire) {
                  submitPostFormFields();
                } else {
                  submitFormFields();
                }
              }}
            />
          }
        </div>
      </form>
    </Box>
  ) : (
    <></>
  );
};

export default SPQuestionnaire;
